import React, { useEffect, useState } from "react";
import axios from "axios";
import Switch from "@mui/joy/Switch";

import AddButton from "../../../../components/admin/usable/AddButton";
import CancelButton from "../../../../components/admin/usable/CancelButton";
import EditButton from "../../../../components/admin/usable/actions/EditButton";
import DeleteButton from "../../../../components/admin/usable/actions/DeleteButton";
import TableLoader from "../../../../components/admin/usable/TableLoader";
import axiosInstance from "../../../../axiosInstance";
import toast from "react-hot-toast";
import {
  viewCountry,
  addCountry,
  updateCountry,
  deleteCountry,
} from "../../../../api/admin/countryApi";

const Country = () => {
  const [CountryData, setCountryData] = useState([]);
  const [Loading, setLoading] = useState(true);
  const [Submitting, setSubmitting] = useState(false);

  const [FormData, setFormData] = useState({
    id: null,
    countryName: "",
    isDefault: 0,
    status: 1,
  });

  // GET
  useEffect(() => {
    viewCountry(setCountryData, setLoading);
  }, []);
  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleDefaultChange = (event) => {
    setFormData((prev) => ({
      ...prev,
      isDefault: event.target.checked ? 1 : 0,
    }));
  };
  const resetForm = () => {
    setFormData({
      id: null,
      countryName: "",
      isDefault: 0,
      status: 1,
    });
  };
  // ADD / UPDATE
  const handleSubmit = () => {
    if (!FormData.countryName.trim()) {
      toast.error("Country name is required");
      return;
    }

    const payload = {
      ...FormData,
      countryName: FormData.countryName.trim(),
      isDefault: Number(FormData.isDefault),
      status: Number(FormData.status),
    };

    if (FormData.id) {
      updateCountry(payload, setFormData, setCountryData, setLoading);
    } else {
      addCountry(payload, setFormData, setCountryData, setLoading);
    }
  };

  // EDIT
  const handleEdit = (item) => {
    setFormData({
      id: item.id,
      countryName: item.countryName || "",
      isDefault: Number(item.isDefault),
      status: Number(item.status),
    });
  };

  // DELETE
  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this country?")) {
      deleteCountry(id, setCountryData);
    }
  };
  return (
    <div className="p-5 bg-white rounded-lg space-y-5">
      <div>
        <p className="font-bold">Country</p>
      </div>

      <div className="flex gap-5">
        {/* =====================================================
            FORM
        ====================================================== */}

        <div className="w-[400px] min-h-[300px] border  p-3 bg-white rounded-lg">
          <div>
            <p className="text-sm font-bold pb-3">
              {FormData.id ? "Edit Country" : "Add Country"}
            </p>
          </div>

          <div className="space-y-5">
            {/* COUNTRY NAME */}

            <div>
              <label className="text-xs">Country Name</label>

              <input
                type="text"
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                placeholder="Country Name"
                id="countryName"
                value={FormData.countryName}
                onChange={handleChange}
              />
            </div>

            {/* DEFAULT COUNTRY */}

            <div className="flex items-center justify-between border rounded-lg px-4 py-3">
              <div>
                <p className="text-xs font-semibold">Default Country</p>

                <p className="text-[10px] text-gray-500">
                  Set this country as the default country
                </p>
              </div>

              <Switch
                checked={FormData.isDefault === 1}
                onChange={handleDefaultChange}
                color={FormData.isDefault === 1 ? "success" : "neutral"}
                size="sm"
              />
            </div>

            {/* STATUS */}

            <div>
              <label className="text-xs">Status</label>

              <select
                className="w-full px-4 py-2 rounded-lg border focus:outline-none text-xs"
                value={FormData.status}
                onChange={(e) =>
                  setFormData((prev) => ({
                    ...prev,
                    status: Number(e.target.value),
                  }))
                }
              >
                <option value={1}>Active</option>
                <option value={0}>Inactive</option>
              </select>
            </div>

            {/* ACTION */}

            <div className="flex justify-end items-center pt-2 gap-x-4">
              <CancelButton size="sm" text="Cancel" onClick={resetForm} />

              <AddButton
                size="sm"
                text={
                  Submitting
                    ? "Saving..."
                    : FormData.id
                      ? "Edit Country"
                      : "Add Country"
                }
                onClick={handleSubmit}
                disabled={Submitting}
              />
            </div>
          </div>
        </div>

        {/* =====================================================
            TABLE
        ====================================================== */}

        <div className="flex-1 border  p-3 bg-white rounded-lg">
          <div className="p-4 w-full overflow-x-auto">
            <table className="min-w-full border border-gray-200 bg-white rounded-lg overflow-hidden">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    ID
                  </th>

                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Country Name
                  </th>

                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Default
                  </th>

                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Status
                  </th>

                  <th className="px-4 py-3 text-left text-sm font-semibold text-gray-600">
                    Action
                  </th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-200">
                {Loading ? (
                  <TableLoader colSpan={5} />
                ) : CountryData.length > 0 ? (
                  CountryData.map((item, index) => (
                    <tr key={item.id} className="hover:bg-gray-50">
                      <td className="px-4 py-3 text-sm text-gray-700">
                        {index + 1}
                      </td>

                      <td className="px-4 py-3 text-sm text-gray-700">
                        {item.countryName}
                      </td>

                      <td className="px-4 py-3 text-sm">
                        {Number(item.isDefault) === 1 ? (
                          <span className="px-2 py-1 bg-blue-100 text-blue-700 rounded text-xs">
                            Default
                          </span>
                        ) : (
                          <span className="text-gray-400 text-xs">—</span>
                        )}
                      </td>

                      <td className="px-4 py-3 text-sm">
                        <span
                          className={`px-2 py-1 ${
                            Number(item.status) === 1
                              ? "bg-green-100 text-green-700"
                              : "bg-red-100 text-red-700"
                          } rounded text-xs`}
                        >
                          {Number(item.status) === 1 ? "active" : "inactive"}
                        </span>
                      </td>

                      <td className="px-4 py-3 text-sm flex gap-2">
                        <EditButton
                          text="Edit"
                          onClick={() => handleEdit(item)}
                        />

                        <DeleteButton
                          text="Delete"
                          onClick={() => handleDelete(item.id)}
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan={5}
                      className="px-4 py-10 text-center text-sm text-gray-500"
                    >
                      No country found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Country;
